import type { FieldPolicy } from '@apollo/client';

const authSettingsFieldPolicy: FieldPolicy = {
  merge(existing, incoming, { mergeObjects }) {
    return mergeObjects(existing, incoming);
  },
};

export default authSettingsFieldPolicy;
